"use strict";
function handleShopifySectionSelect(event) {
    const eventDetail = event.detail;
    const sectionElement = document.getElementById(`shopify-section-${eventDetail.sectionId}`);
    if (sectionElement) {
        sectionElement.setAttribute('data-editor-section-selected', 'true');
    }
}
function handleShopifySectionDeselect(event) {
    const eventDetail = event.detail;
    const sectionElement = document.getElementById(`shopify-section-${eventDetail.sectionId}`);
    if (sectionElement) {
        sectionElement.removeAttribute('data-editor-section-selected');
    }
}
function handleShopifyBlockSelect(event) {
    const eventDetail = event.detail;
    const sectionElement = document.getElementById(`shopify-section-${eventDetail.sectionId}`);
    if (sectionElement) {
        const blockElements = sectionElement.querySelectorAll('[data-shopify-editor-block]');
        const selectedBlockElement = [...blockElements].find((blockElement) => {
            try {
                return (
                // TODO: Fix this type error.
                // @ts-ignore
                JSON.parse(blockElement.getAttribute('data-shopify-editor-block')).id ===
                    eventDetail.blockId);
            }
            catch {
                return false;
            }
        });
        if (selectedBlockElement) {
            selectedBlockElement.setAttribute('data-editor-block-selected', 'true');
        }
    }
}
function handleShopifyBlockDeselect(event) {
    const eventDetail = event.detail;
    const sectionElement = document.getElementById(`shopify-section-${eventDetail.sectionId}`);
    if (sectionElement) {
        const blockElements = sectionElement.querySelectorAll('[data-shopify-editor-block]');
        const selectedBlockElement = [...blockElements].find((blockElement) => {
            try {
                return (
                // TODO: Fix this type error.
                // @ts-ignore
                JSON.parse(blockElement.getAttribute('data-shopify-editor-block')).id ===
                    eventDetail.blockId);
            }
            catch {
                return false;
            }
        });
        if (selectedBlockElement) {
            selectedBlockElement.removeAttribute('data-editor-block-selected');
        }
    }
}
document.addEventListener('shopify:section:select', handleShopifySectionSelect);
document.addEventListener('shopify:section:deselect', handleShopifySectionDeselect);
document.addEventListener('shopify:block:select', handleShopifyBlockSelect);
document.addEventListener('shopify:block:deselect', handleShopifyBlockDeselect);
